import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { AeroNav } from "@/components/aero/AeroNav";
import { AeroHero } from "@/components/aero/AeroHero";
import { StatsBar } from "@/components/aero/StatsBar";
import { FeaturedOn } from "@/components/aero/FeaturedOn";
import { ReelsStrip } from "@/components/aero/ReelsStrip";
import { AeroFilmography } from "@/components/aero/AeroFilmography";
import { AeroAbout } from "@/components/aero/AeroAbout";
import { FilmSchoolTeaser } from "@/components/aero/FilmSchoolTeaser";
import { ContactSection } from "@/components/aero/ContactSection";
import { AeroFooter } from "@/components/aero/AeroFooter";
import { WhatsAppFloat } from "@/components/cine/WhatsAppFloat";
import { BookingModal } from "@/components/landing/BookingModal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CinematicLanding() {
  const [consultOpen, setConsultOpen] = useState(false);
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    // deep-link scroll (e.g. /#about from /film-school)
    const hash = window.location.hash;
    if (hash) {
      const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView(), 600);
      return () => clearTimeout(t);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    const token = localStorage.getItem("session_token");
    if (!token) {
      setUser(null);
      return;
    }
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("session_token");
        setUser(null);
      });
  }, []);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    const token = localStorage.getItem("session_token");
    try {
      await axios.post(`${API}/auth/logout`, {}, { headers: { Authorization: `Bearer ${token}` } });
    } catch {}
    localStorage.removeItem("session_token");
    setUser(null);
    toast.success("Logged out.");
  };

  return (
    <main className="bg-white text-ink overflow-x-clip" data-testid="aero-home">
      <AeroNav />
      <AeroHero />
      <FeaturedOn />
      <StatsBar />
      <ReelsStrip />
      <AeroFilmography />
      <AeroAbout />
      <FilmSchoolTeaser />
      <ContactSection onConsult={() => setConsultOpen(true)} />
      <AeroFooter />
      <BookingModal
        open={consultOpen}
        onClose={() => setConsultOpen(false)}
        user={user}
        onLogin={login}
        onLogout={logout}
      />
      <WhatsAppFloat />
    </main>
  );
}
